import React from 'react';
import { HeadingContainer, SubHeadingContainer } from './Style.js'
import { FormattedMessage } from 'react-intl';
const Heading = (props) => {

    return (
        <>
            <HeadingContainer>
                <FormattedMessage id={props.headingId}/>
            </HeadingContainer>
            <SubHeadingContainer>
                <FormattedMessage id={props.subHeadingId}/>
            </SubHeadingContainer>
        </>
    );
}

export default Heading ;